<template>
  <v-container id="recibos-caplp">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  class="alineacentro DatosMatriculado"
                  dark
                  color="success"
                >
                  <strong>RECIBOS DE TESORERIA</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-spacer />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="2" lg="2">
                <v-menu
                  v-model="menufiltrofdesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfdesde"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtros.desde"
                    @input="menufiltrofdesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-menu
                  v-model="menufiltrofhasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfhasta"
                      label="Hasta"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtros.hasta"
                    @input="menufiltrofhasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-text-field
                  v-model="filtros.recibodesde"
                  label="Recibo Desde"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-text-field
                  v-model="filtros.recibohasta"
                  label="Recibo Hasta"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  v-model="filtros.idpuntoventa"
                  :items="listapuntosventa"
                  label="Talonario"
                  item-text="puntoventa"
                  item-value="idpuntoventa"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="filtros.nombre"
                  label="Nombre"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="filtros.detalle"
                  label="Detalle"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6" class="alineaderecha">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar"
                  @click="ListarRecibos('')"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Nuevo Recibo de Tesorería"
                  @click="NuevoRecibo"
                  :disabled="!permisoescritura"
                >
                  <v-icon dark> mdi-new-box </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Informar Recibo en AFIP"
                  @click="InformaAFIP"
                  :disabled="
                    reciboseleccionado.length === 0 ||
                    !permisoescritura ||
                    reciboseleccionado[0].idestado > 1 ||
                    reciboseleccionado[0].pvtipo != 2
                  "
                >
                  AFIP <v-icon dark> mdi-file-send </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Generar Recibo en Talonario Manual"
                  @click="ReciboManual"
                  :disabled="
                    reciboseleccionado.length === 0 ||
                    !permisoescritura ||
                    reciboseleccionado[0].idestado === 2 ||
                    (reciboseleccionado[0].idestado > 1 &&
                      reciboseleccionado[0].pvtipo === 2) ||
                    (reciboseleccionado[0].idestado === 1 &&
                      reciboseleccionado[0].pvtipo === 1)
                  "
                >
                  Manual <v-icon dark> mdi-receipt-text-check </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Anular Recibo"
                  @click="AbreCuadroAnularRecibo"
                  :disabled="
                    reciboseleccionado.length === 0 ||
                    !permisoescritura ||
                    reciboseleccionado[0].idestado === 2
                  "
                >
                  <v-icon dark> mdi-close </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="success"
                  title="Re-Imprimir Recibo"
                  @click="AbrirCuadroReImprimir"
                  :disabled="
                    reciboseleccionado.length === 0 ||
                    !permisolectura ||
                    reciboseleccionado[0].idestado === 2
                  "
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Imprimir o Exportar Listado"
                  @click="AbrirCuadroImprimirExportar"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-data-table
                  v-model="reciboseleccionado"
                  :headers="columnasrecibos"
                  :items="listarecibos"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                  }"
                  single-select
                  show-select
                  item-key="recibo"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.recestado="{ item }">
                    <v-chip :color="getColor(item.idestado)" dark>
                      {{ item.recestado }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialognuevorecibo" fullscreen>
      <v-card>
        <v-card-title class="headline">
          Nuevo Recibo de Tesorería
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="GrabarNuevoRecibo">
                Grabar
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialognuevorecibo = false"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-row row wrap>
            <v-col cols="12" md="9" lg="9">
              <br />
              <v-card flat height="auto" color="grey" class="alineacentro" min-height="260">
                <v-card-text class="titulocardchico TituloGrilla2">
                  <strong>CABECERA - TALONARIO Y PERSONA</strong>
                </v-card-text>
                <v-card-text>
                  <v-row row wrap>
                    <v-col cols="12" md="4" lg="4">
                      <v-text-field
                        v-model="recibo.titulo"
                        label="Detalle"
                        height="20px"
                      />
                    </v-col>
                    <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                      <v-select
                        v-model="recibo.idpuntoventa"
                        :items="listatalonarios"
                        label="Talonario"
                        item-text="puntoventa"
                        item-value="idpuntoventa"
                        class="ocupa90"
                        height="20px"
                      />
                    </v-col>
                    <v-col cols="12" md="1" lg="1" class="alineacentro" v-if="recibo.idpuntoventa != '' && listatalonarios.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1">
                      <v-text-field
                        :value="parseInt(listatalonarios.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].ultnrorecibo) + 1"
                        label="N° Recibo"
                        class="ocupa90"
                        height="20px"
                        readonly
                      />
                    </v-col>
                    <v-col cols="12" :md="recibo.idpuntoventa != '' && listatalonarios.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1 ? 2 : 3" :lg="recibo.idpuntoventa != '' && listatalonarios.filter((t) => t.idpuntoventa === recibo.idpuntoventa)[0].idtipo === 1 ? 2 : 3" class="alineaizquierda">
                      <v-menu
                        v-model="menufrec"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechalocalrecibo"
                            label="Fecha"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            class="ocupa90"
                            height="20px"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="recibo.fecha"
                          @input="menufrec = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <selector-persona
                        ref="selpersonarecibo"
                        roles="1-2-3"
                        class="alineaizquierda"
                        @selPersona="asignapersona"
                      ></selector-persona>
                    </v-col>
                  </v-row>
                  <v-row row wrap v-if="recibo.relevardatosfiscales">
                    <v-col cols="6">
                      <v-radio-group label="Facturar como:" v-model="selcondicioniva" row>
                        <v-radio
                          key="1"
                          label="Consumidor Final"
                          value="1"
                        ></v-radio>
                        <v-radio
                          key="2"
                          label="Otra condición"
                          value="2"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        label="CUIT"
                        class="ocupa90"
                        height="20px"
                        v-model="recibo.cuitpersona"
                        :disabled="selcondicioniva==='1'"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-select
                        v-model="recibo.idcondicionivapersona"
                        :items="listacondicionesiva"
                        label="Cond. IVA"
                        item-text="nombre"
                        item-value="idcondicioniva"
                        class="ocupa90"
                        height="20px"
                        :disabled="selcondicioniva==='1'"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <br />
              <v-card flat height="auto" color="grey" class="alineacentro" min-height="260">
                <v-card-text class="titulocardchico TituloGrilla2">
                  <strong>TOTALES</strong>
                </v-card-text>
                <v-card-text>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-card
                        flat
                        height="50"
                        dark
                        color="red"
                        class="alineaderecha"
                      >
                        <v-card-text class="textoNegritaMontos">
                          <strong>A COBRAR: $ {{ sumamontorecibo() }}</strong>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-card
                        flat
                        height="50"
                        dark
                        color="success"
                        class="alineaderecha"
                      >
                        <v-card-text class="textoNegritaMontos">
                          <strong
                            >DESCUENTOS: $ {{ sumamontodescuentos() }}</strong
                          >
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-card
                        flat
                        height="50"
                        dark
                        color="success"
                        class="alineaderecha"
                      >
                        <v-card-text class="textoNegritaMontos">
                          <strong>ABONOS: $ {{ sumamontopagos() }}</strong>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-card
                        flat
                        height="50"
                        dark
                        :color="
                          sumamontorecibo() -
                            sumamontodescuentos() -
                            sumamontopagos() ===
                          0
                            ? 'info'
                            : sumamontorecibo() - sumamontopagos() < 0
                            ? 'success'
                            : 'red'
                        "
                        class="alineaderecha"
                      >
                        <v-card-text class="textoNegritaMontos">
                          <strong
                            >SALDO: $
                            {{
                              (
                                sumamontorecibo() -
                                sumamontodescuentos() -
                                sumamontopagos()
                              ).toFixed(2)
                            }}</strong
                          >
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12">
              <v-card flat height="auto" color="grey" class="alineacentro">
                <v-card-text class="titulocardchico TituloGrilla2">
                  <strong>DETALLE DEL RECIBO</strong>
                </v-card-text>
                <v-card-text>
                  <v-row row wrap>
                    <v-col cols="12" md="8" lg="8">
                      <v-card
                        flat
                        height="auto"
                        color="red"
                        class="alineacentro"
                      >
                        <v-card-text class="titulocardchico">
                          <strong>Items a Imputar</strong>
                        </v-card-text>
                        <v-card-text>
                          <!--<v-row row wrap>
                            <v-col cols="12" class="alineaderecha">
                               <v-btn
                                class="ma-2"
                                dark
                                small
                                color="primary"
                                title="Agregar Items Actividades Académicas"
                                @click="BuscaItemDebeAA"
                            >
                                <v-icon dark> mdi-account-school </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>-->
                          <!-- <v-row row wrap>
                            <v-col cols="12" md="1" lg="1">
                              <v-text-field
                                v-model="nuevoitemdebe.numero"
                                label="N°"
                                type="number"
                                v-on:keyup.enter="BuscarCuenta"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="2" lg="2">
                              <v-text-field
                                v-model="nuevoitemdebe.codigo"
                                label="Código"
                                readonly
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="5" lg="5">
                              <v-text-field
                                v-model="nuevoitemdebe.descripcion"
                                label="Concepto"
                                readonly
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="2" lg="2">
                              <v-text-field
                                v-model="nuevoitemdebe.importe"
                                label="Importe"
                                type="number"
                                prefix="$"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="2" lg="2">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="primary"
                                title="Agregar Item a Pagar"
                                @click="AgregaNuevoItemDebe"
                              >
                                <v-icon dark> mdi-cash-plus</v-icon>
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                dark
                                x-small
                                color="primary"
                                title="Agregar Items Desde CC"
                                @click="BuscaItemDebeCC"
                              >
                                <v-icon dark> mdi-account-cash </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row> -->
                          <v-row row wrap>
                            <v-col cols="12" md="8" lg="8">
                              <selector-cuenta ref="selcuentarecibo"
                                @selCuenta="seleccionarcuenta" idseleccionado="0">
                              </selector-cuenta>
                            </v-col>
                            <v-col cols="12" md="2" lg="2">
                              <v-text-field
                                ref="importecuentadebe"
                                v-model="nuevoitemdebe.importe"
                                label="Importe"
                                type="number"
                                prefix="$"
                                height="20px"
                              />
                            </v-col>
                            <v-col cols="12" md="2" lg="2">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="primary"
                                title="Agregar Item a Pagar"
                                @click="AgregaNuevoItemDebe"
                              >
                                <v-icon dark> mdi-cash-plus</v-icon>
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                dark
                                x-small
                                color="primary"
                                title="Agregar Items Desde CC"
                                @click="BuscaItemDebeCC"
                              >
                                <v-icon dark> mdi-account-cash </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                v-model="itemdebeseleccionado"
                                :headers="columnasdebe"
                                :items="recibo.itemsdebe"
                                :items-per-page="10"
                                :footer-props="{
                                  'items-per-page-text': 'Filas por Página:',
                                  'items-per-page-all-text': 'Todos',
                                }"
                                item-key="iddebe"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                              >
                                <template v-slot:item.imputa="props">
                                  <!-- <v-text-field
                                    v-model="props.item.imputa"
                                    label="Monto que Imputa"
                                    type="number"
                                    height="20px"
                                    :rules="[(v) => v >= props.item.interes || 'Imputación debe ser mayor que interes',
                                      (v) => v > 0 || 'Imputación requerida',
                                    ]"
                                  /> -->
                                  <v-text-field
                                    v-model="props.item.imputa"
                                    label="Monto que Imputa"
                                    type="number"
                                    height="20px"
                                    :rules="[(v) => v > 0 || 'Imputación requerida']"
                                  />
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <v-icon small @click="QuitarItemDebe(item)">
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                          <!-- <v-row row wrap>
                                <v-col cols="12">
                                <v-card flat height="35" dark color="info" class="alineacentro">
                                    <v-card-text class="titulocardchico">
                                    <strong>DESCUENTOS</strong>
                                    </v-card-text>
                                </v-card>
                                </v-col>
                            </v-row>
                            <v-row row wrap>
                                <v-col cols="12" md="1" lg="1">
                                <v-text-field
                                    v-model="nuevoitemdesc.numero"
                                    label="N°"
                                    type="number"
                                    v-on:keyup.enter="BuscarCuenta"
                                />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                <v-text-field
                                    v-model="nuevoitemdesc.codigo"
                                    label="Código"
                                    readonly
                                />
                                </v-col>
                                <v-col cols="12" md="6" lg="6">
                                <v-text-field
                                    v-model="nuevoitemdesc.descripcion"
                                    label="Concepto"
                                    readonly
                                />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                <v-text-field
                                    v-model="nuevoitemdesc.importe"
                                    label="Importe"
                                    type="number"
                                />
                                </v-col>
                                <v-col cols="12" md="1" lg="1">
                                <v-btn
                                    class="ma-2"
                                    small
                                    color="red"
                                    title="Agregar Item a Descontar"
                                    @click="AgregaNuevoItemDesc"
                                >
                                    <v-icon dark> mdi-cash-minus</v-icon>
                                </v-btn>
                                </v-col>
                            </v-row>
                            <v-row row wrap>
                                <v-col cols="12">
                                <v-data-table
                                    v-model="itemdescuentoseleccionado"
                                    :headers="columnasdescuentos"
                                    :items="recibo.itemsdescuentos"
                                    :items-per-page="10"
                                    :footer-props="{
                                        'items-per-page-text': 'Filas por Página:',
                                        'items-per-page-all-text': 'Todos',
                                    }"
                                    single-select
                                    show-select
                                    item-key="iddescuento"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Registros"
                                    multi-sort
                                    >
                                    <template v-slot:item.actions="{ item }">
                                    <v-icon
                                        small
                                        @click="QuitarItemDesc(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    </template>
                                </v-data-table>
                                </v-col>
                            </v-row> -->
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <v-card
                        flat
                        height="auto"
                        color="success"
                        class="alineacentro"
                      >
                        <v-card-text class="titulocardchico">
                          <strong>Saldos a Favor</strong>
                        </v-card-text>
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnassaldofavor"
                                :items="recibo.itemssaldofavor"
                                hide-default-footer
                                item-key="idsaldofavor"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-card
                        flat
                        height="auto"
                        color="success"
                        class="alineacentro"
                      >
                        <v-card-text class="titulocardchico">
                          <v-row row wrap>
                            <v-col cols="12" md="8" lg="8">
                              <strong>Descuentos</strong>
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                              <v-btn
                                class="ma-2"
                                dark
                                x-small
                                color="primary"
                                title="Agregar Nuevo Descuento"
                                @click="AgregarDescuento"
                              >
                                <v-icon dark> mdi-cash-minus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-data-table
                                :headers="columnasdescuentos"
                                :items="recibo.itemsdescuentos"
                                hide-default-footer
                                item-key="iddescuento"
                                class="elevation-1"
                                dense
                                no-data-text="Sin Registros"
                                multi-sort
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-icon
                                    small
                                    @click="QuitarItemDescuento(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12">
              <v-card flat height="auto" color="success" class="alineacentro">
                <v-card-text class="titulocardchico TituloGrilla2">
                  <strong>MONTO Y TIPOS DE PAGO</strong>
                </v-card-text>
                <v-card-text>
                  <v-row row wrap>
                    <v-col cols="12" class="alineaderecha">
                      <v-btn
                        class="ma-2"
                        dark
                        x-small
                        color="primary"
                        title="Editar Formas de Pago"
                        @click="ModificarPagos"
                      >
                        <v-icon dark> mdi-cash-plus </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-data-table
                        v-model="itemabonoseleccionado"
                        :headers="columnasabonos"
                        :items="recibo.itemsabonos.filter((r) => r.importe > 0)"
                        hide-default-footer
                        item-key="idformapago"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                      >
                        <!-- <template v-slot:item.actions="{ item }">
                        <v-icon
                            small
                            @click="QuitarItemAbono(item)"
                        >
                            mdi-delete
                        </v-icon>
                        </template> -->
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialognuevoitemdebe" persistent max-width="1200">
      <v-card>
        <v-card-title class="headline">
          Agregar Items Debe para : {{ recibo.persona }}
          {{ recibo.nromatriculado != 0 ? " - (Mat. N°: " + recibo.nromatriculado + ")" : "" }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="SeleccionarItemsDebe">
                Seleccionar Items
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialognuevoitemdebe = false"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <v-row row wrap v-if="recibo.nromatriculado != 0">
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-row row wrap>
                    <v-col cols="12" lg="4" md="4">
                      <v-menu
                        v-model="menufintCC"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechalocalfinteres"
                            label="Fecha"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            height="20px"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechainteresCC"
                          @input="menufintCC = false"
                          @change="ListarCCMatriculado()"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" lg="8" md="8">
                      <v-btn
                        class="ma-2"
                        dark
                        x-small
                        color="primary"
                        title="Listar CC del Matriculado"
                        @click="ListarCCMatriculado()"
                      >
                        <v-icon dark> mdi-magnify </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <!-- <v-col cols="12" lg="9" md="9" class="alineaizquierda">
                      <v-checkbox
                        v-if="listaccmatriculado.filter(c=> c.cuotaanual===(new Date()).getFullYear()).length>0"
                        :disabled="listaccmatriculado.filter(c=> c.cuotaanual===(new Date()).getFullYear() && c.interes>0).length>0"
                        label="Pago Único Mat. Actual"
                        dense
                        v-model="pagounico"
                        @change="PagoUnicoMatriculaActual()"
                      ></v-checkbox>
                    </v-col> -->
                    <v-col
                      cols="12"
                      class="alineaderecha info textoNegritaTitulo"
                    >
                      Total Seleccionado: $ {{ sumaitemsselcc }}
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-card
                        flat
                        height="35"
                        dark
                        color="info"
                        class="alineacentro"
                      >
                        <v-card-text class="titulocardchico">
                          <strong>CUENTA CORRIENTE DEL MATRICULADO</strong>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-data-table
                        v-model="itemsccmatseleccionado"
                        :headers="columnasccmatriculado"
                        :items="listaccmatriculado"
                        :items-per-page="10"
                        :footer-props="{
                          'items-per-page-text': 'Filas por Página:',
                          'items-per-page-all-text': 'Todos',
                        }"
                        show-select
                        item-key="idmovimientocc"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row row wrap class="info textoNegritaTitulo">
                    <v-col cols="12">
                      Total Seleccionado: $ {{ sumaitemsselcc }}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogformaspagos" persistent fullscreen>
      <v-card>
        <v-card-title class="headline"> Formas de Pago </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" md="2" lg="2" class="alineaizquierda">
              <v-btn color="primary" text @click="verdebeenfp = !verdebeenfp">
                {{ verdebeenfp ? "Ocultar Detalles Recibo" : "Ver Detalles Recibo" }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="10" lg="10" class="alineaderecha">
              <v-btn color="green darken-1" text @click="GuardarFormasPago">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="CancelarFormasPago">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-spacer />
            </v-col>
          </v-row>
          <v-row v-if="verdebeenfp">
            <v-col cols="12">
              <v-data-table
                :headers="columnasdeudafp"
                :items="listadeudafp"
                item-key="concepto"
                class="elevation-1"
                :items-per-page="100"
                dense
                hide-default-footer
                item-class="estilo"
                no-data-text="Sin Registros"
              >
              </v-data-table>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-spacer />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-tabs
                centered
                color="#4bc47f"
                dark
                icons-and-text
                v-model="tabactivofp"
              >
                <v-tabs-slider color="#2a6bbf" />
                <v-tab href="#tab-1" key="Totales">
                  Totales
                  <v-icon>mdi-sigma</v-icon>
                </v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Forma de Pago</th>
                              <th class="text-left">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in recibo.itemsabonos"
                              :key="item.idformapago"
                            >
                              <td>{{ item.descripcion }}</td>
                              <td>{{ item.importe }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-2" key="HaberCC">
                  Haber en CC
                  <v-icon>mdi-cash</v-icon>
                </v-tab>
                <v-tab-item value="tab-2">
                  <v-card>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          Importe total seleccionado por Haber en CC: {{ sumamontohaber().toFixed() }}
                        </v-col>
                      </v-row>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-data-table
                            v-model="recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].registroshcc"
                            :headers="columnasfphcccomp"
                            :items="listacchabermatriculado"
                            :items-per-page="10"
                            :footer-props="{
                              'items-per-page-text': 'Filas por Página:',
                              'items-per-page-all-text': 'Todos',
                            }"
                            item-key="idmovimientocc"
                            show-select
                            class="elevation-1"
                            dense
                            no-data-text="Sin Movimientos de Haber"
                            multi-sort
                          >
                            <template v-slot:item.imputa="{ item }">
                              <v-text-field
                                v-model="item.imputa"
                                type="number"
                                dense
                                :disabled="recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].registroshcc.filter((t) =>t.idmovimientocc === item.idmovimientocc).length === 0"
                              />
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-3" key="Efectivo">
                  Efectivo
                  <v-icon>mdi-cash</v-icon>
                </v-tab>
                <v-tab-item value="tab-3">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-text-field v-model="recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].importe"
                            label="Importe"
                            type="number"
                            prefix="$"
                            height="20px"
                          />
                        </v-col>
                      </v-row>
                      <v-row row wrap v-if="recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].importe > 0">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <v-row row wrap>
                                <v-col cols="12" lg="2" md="2">
                                  <v-text-field
                                    v-model="rec_fp_efe_nrocomp"
                                    label="N° Comp."
                                    type="number"
                                    height="20px"
                                    :rules="[rulesnrocomp.counter]"
                                  />
                                </v-col>
                                <v-col cols="12" lg="4" md="4">
                                  <v-text-field
                                    v-model="rec_fp_efe_detalle"
                                    label="Detalle"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="3" md="3">
                                  <v-select
                                    v-model="rec_fp_efe_idcuenta"
                                    :items="listacuentasbancarias"
                                    label="Cuenta Bancaria"
                                    item-text="cuenta"
                                    item-value="idcuenta"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    ref="rec_fp_efe_importe"
                                    v-model="rec_fp_efe_importe"
                                    label="Importe"
                                    type="number"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="1" md="1">
                                  <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Comprobante"
                                    @click="AgregarCompEfectivo"
                                  >
                                    <v-icon dark> mdi-receipt-outline</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-row row wrap>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="columnasfpefecomp"
                                    :items="recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].registros"
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text':
                                        'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="nrocomprobante"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Comprobantes"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-icon
                                        small
                                        @click="QuitarCompEfectivo(item)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-4" key="Cheques">
                  Cheques
                  <v-icon>mdi-checkbook</v-icon>
                </v-tab>
                <v-tab-item value="tab-4">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-text-field
                            v-model="
                              recibo.itemsabonos.filter(
                                (f) => f.idformapago === 2
                              )[0].importe
                            "
                            label="Importe"
                            type="number"
                            prefix="$"
                            height="20px"
                          />
                        </v-col>
                      </v-row>
                      <v-row
                        row
                        wrap
                        v-if="
                          recibo.itemsabonos.filter(
                            (f) => f.idformapago === 2
                          )[0].importe > 0
                        "
                      >
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <v-row row wrap>
                                <v-col cols="12" lg="2" md="2">
                                  <v-text-field
                                    v-model="rec_fp_cheq_banco"
                                    label="Banco"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="2" md="2">
                                  <v-text-field
                                    v-model="rec_fp_cheq_nrocheq"
                                    label="N° Cheq."
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="2" md="2">
                                  <v-menu
                                    v-model="menufcheq"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="fechalocalrec_fp_cheq_fecha"
                                        label="Fecha"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        height="20px"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="rec_fp_cheq_fecha"
                                      @input="menufcheq = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" lg="2" md="2">
                                  <v-menu
                                    v-model="menufcheqvenc"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="
                                          fechalocalrec_fp_cheq_vencimiento
                                        "
                                        label="Venc."
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        height="20px"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="rec_fp_cheq_vencimiento"
                                      @input="menufcheqvenc = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" lg="2" md="2">
                                  <v-checkbox
                                    v-model="rec_fp_cheq_alaorden"
                                    label="A la Orden"
                                    height="20px"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" lg="1" md="1">
                                  <v-text-field
                                    v-model="rec_fp_cheq_importe"
                                    label="Importe"
                                    type="number"
                                    prefix="$"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="1"
                                  md="1"
                                  class="alineacentro"
                                >
                                  <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Cheque"
                                    @click="AgregarCheque"
                                  >
                                    <v-icon dark> mdi-checkbook</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-row row wrap>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="columnasfpcheques"
                                    :items="
                                      recibo.itemsabonos.filter(
                                        (f) => f.idformapago === 2
                                      )[0].registros
                                    "
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text':
                                        'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="nrocomprobante"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Comprobantes"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-icon small @click="QuitarCheque(item)">
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-5" key="Deposito">
                  Dep. Bancario
                  <v-icon>mdi-cash-fast</v-icon>
                </v-tab>
                <v-tab-item value="tab-5">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-text-field v-model="recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].importe"
                            label="Importe"
                            type="number"
                            prefix="$"
                            height="20px"
                          />
                        </v-col>
                      </v-row>
                      <v-row row wrap v-if="recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].importe > 0">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <v-row row wrap>
                                <v-col cols="12" lg="2" md="2">
                                  <v-text-field
                                    v-model="rec_fp_dep_nrocomp"
                                    label="N° Comp."
                                    type="number"
                                    height="20px"
                                    :rules="[rulesnrocomp.counter]"
                                  />
                                </v-col>
                                <v-col cols="12" lg="5" md="5">
                                  <v-text-field
                                    v-model="rec_fp_dep_detalle"
                                    label="Detalle"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="4" md="4">
                                  <v-select
                                    v-model="rec_fp_dep_idcuenta"
                                    :items="listacuentasbancarias"
                                    label="Cuenta Bancaria"
                                    item-text="cuenta"
                                    item-value="idcuenta"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    ref="rec_fp_dep_importe"
                                    v-model="rec_fp_dep_importe"
                                    label="Importe"
                                    type="number"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="1" md="1">
                                  <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Comprobante"
                                    @click="AgregarCompDeposito"
                                  >
                                    <v-icon dark> mdi-receipt-outline</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-row row wrap>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="columnasfpdepcomp"
                                    :items="recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].registros"
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text':
                                        'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="nrocomprobante"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Comprobantes"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-icon
                                        small
                                        @click="QuitarCompDeposito(item)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-6" key="Transferencia">
                  Transf. Bancaria
                  <v-icon>mdi-bank-transfer</v-icon>
                </v-tab>
                <v-tab-item value="tab-6">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-text-field v-model="recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].importe"
                            label="Importe"
                            type="number"
                            prefix="$"
                            height="20px"
                          />
                        </v-col>
                      </v-row>
                      <v-row row wrap v-if="recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].importe > 0">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <v-row row wrap>
                                <v-col cols="12" lg="2" md="2">
                                  <v-text-field
                                    v-model="rec_fp_tra_nrocomp"
                                    label="N° Comp."
                                    type="number"
                                    height="20px"
                                    :rules="[rulesnrocomp.counter]"
                                  />
                                </v-col>
                                <v-col cols="12" lg="4" md="4">
                                  <v-text-field
                                    v-model="rec_fp_tra_detalle"
                                    label="Detalle"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="3" md="3">
                                  <v-select
                                    v-model="rec_fp_tra_idcuenta"
                                    :items="listacuentasbancarias"
                                    label="Cuenta Bancaria"
                                    item-text="cuenta"
                                    item-value="idcuenta"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    ref="rec_fp_tra_importe"
                                    v-model="rec_fp_tra_importe"
                                    label="Importe"
                                    type="number"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" lg="1" md="1">
                                  <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Comprobante"
                                    @click="AgregarCompTransferencia"
                                  >
                                    <v-icon dark> mdi-receipt-outline</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-row row wrap>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="columnasfptracomp"
                                    :items="recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].registros"
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text':
                                        'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="nrocomprobante"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Comprobantes"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-icon
                                        small
                                        @click="QuitarCompTransferencia(item)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-7" key="OtrasCuentas">
                  Otras Cuentas
                  <v-icon>mdi-cash-multiple</v-icon>
                </v-tab>
                <v-tab-item value="tab-7">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12">
                          <v-text-field v-model="recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe"
                            label="Importe"
                            type="number"
                            prefix="$"
                            height="20px"
                          />
                        </v-col>
                      </v-row>
                      <v-row row wrap v-if="recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe > 0">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <!-- <v-row row wrap>
                                <v-col cols="12" md="1" lg="1">
                                  <v-text-field
                                    v-model="rec_fp_ocu_numero"
                                    label="N°"
                                    type="number"
                                    height="20px"
                                    v-on:keyup.enter="BuscarCuentaFPOC"
                                  />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    v-model="rec_fp_ocu_codigo"
                                    label="Código"
                                    height="20px"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="12" md="6" lg="6">
                                  <v-text-field
                                    v-model="rec_fp_ocu_descripcion"
                                    label="Concepto"
                                    height="20px"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    v-model="rec_fp_ocu_importe"
                                    label="Importe"
                                    type="number"
                                  />
                                </v-col>
                                <v-col cols="12" md="1" lg="1">
                                  <v-btn
                                    class="ma-2"
                                    x-small
                                    color="red"
                                    title="Agregar Cuenta"
                                    @click="AgregaCuentaFPOC"
                                  >
                                    <v-icon dark> mdi-cash-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row> -->
                              <v-row row wrap>
                                <v-col cols="12" md="9" lg="9">
                                  <selector-cuenta ref="selcuentarecibofpoc"
                                    @selCuenta="seleccionarcuentafpoc" idseleccionado="0">
                                  </selector-cuenta>
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                  <v-text-field
                                    ref="rec_fp_ocu_importe"
                                    v-model="rec_fp_ocu_importe"
                                    label="Importe"
                                    type="number"
                                    height="20px"
                                  />
                                </v-col>
                                <v-col cols="12" md="1" lg="1">
                                  <v-btn
                                    class="ma-2"
                                    x-small
                                    color="red"
                                    title="Agregar Cuenta"
                                    @click="AgregaCuentaFPOC"
                                  >
                                    <v-icon dark> mdi-cash-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <v-row row wrap>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="columnasfpOC"
                                    :items="
                                      recibo.itemsabonos.filter(
                                        (f) => f.idformapago === 11
                                      )[0].registros
                                    "
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text':
                                        'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="iddebe"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Registros"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-icon
                                        small
                                        @click="QuitarCuentaFPOC(item)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab href="#tab-8" key="Dolares">
                  Dólares
                  <v-icon>mdi-cash-100</v-icon>
                </v-tab>
                <v-tab-item value="tab-8">
                  <v-card flat>
                    <v-card-text>
                      <v-row row wrap>
                        <v-col cols="12" lg="4" md="4">
                          <v-text-field
                            v-model="
                              recibo.itemsabonos.filter(
                                (f) => f.idformapago === 9
                              )[0].importe
                            "
                            label="Importe"
                            type="number"
                            height="20px"
                          />
                        </v-col>
                        <v-col cols="12" lg="8" md="8">
                          <v-text-field
                            v-model="
                              recibo.itemsabonos.filter(
                                (f) => f.idformapago === 9
                              )[0].valordolar
                            "
                            label="Valor Dólar"
                            type="number"
                            prefix="$"
                            height="20px"
                            class="ocupa30"
                            v-if="
                              recibo.itemsabonos.filter(
                                (f) => f.idformapago === 9
                              )[0].importe > 0
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogverexportar" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Exportar Listado </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="alineaizquierda">
              <v-select
                v-model="formatosel"
                :items="listaformatos"
                label="Formato"
                outlined
                item-text="formato"
                item-value="formato"
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="exportarlistado">
            Exportar
          </v-btn>
          <v-btn color="red darken-1" text @click="dialogverexportar = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogrecibomanual" persistent max-width="600">
      <v-card>
        <v-card-title class="headline"> Cambiar a Recibo Manual </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="CambiarReciboManual">
                Cambiar
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialogrecibomanual = false"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row row wrap>
            <v-col cols="12" class="TituloGrilla2 textocentrado">
              Punto de Venta Actual: {{ cambiomanual.puntoventaactual }}
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12">
              <v-select
                v-model="cambiomanual.idpuntoventanuevo"
                :items="listapuntosventamanual"
                label="Nuevo Punto de Venta"
                item-text="puntoventa"
                item-value="idpuntoventa"
              />
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" class="textoNegritaRojo textocentrado">
              Próx Nro Recibo: {{ cambiomanual.proxnumerorecibo }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogdescuento" persistent max-width="1024">
      <v-card>
        <v-card-title class="headline"> Nuevo Descuento </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="GrabarDescuento">
                Grabar Descuento
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogdescuento = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row row wrap>
            <v-col cols="12" lg="6" md="6">
              <v-select
                v-model="rec_desc_idtipodescuento"
                :items="listatiposdescuentos"
                label="Tipo"
                item-text="nombre"
                item-value="idtipodescuento"
                height="20px"
              />
            </v-col>
            <v-col cols="12" lg="6" md="6">
              <v-text-field
                v-model="rec_desc_concepto"
                label="Concepto"
                height="20px"
              />
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" lg="6" md="6">
              <v-text-field
                v-model="rec_desc_importe"
                label="Importe"
                type="number"
                height="20px"
              />
            </v-col>
            <v-col cols="12" lg="6" md="6">
              <v-text-field
                v-model="rec_desc_porcentaje"
                label="Porcentaje"
                type="number"
                height="20px"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorPersona from "../../components/SelectorPersona.vue";
import SelectorCuenta from "../../components/SelectorCuenta.vue";
export default {
  name: "RecibosTesoreria",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorPersona,
    SelectorCuenta
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 23,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      menufiltrofdesde: false,
      menufiltrofhasta: false,
      filtros: {
        desde: "",
        hasta: "",
        recibodesde: "",
        recibohasta: "",
        nombre: "",
        idtiporecibo: -1,
        idpuntoventa: -1,
        detalle: "",
      },
      listarecibos: [],
      columnasrecibos: [
        {
          text: "PV",
          align: "center",
          sortable: true,
          value: "recpvta",
          width: 70,
        },
        /* {
            text: "PVAFIP",
            align: "center",
            sortable: true,
            value: "recpvtaafip",
            width: 100
          }, */
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "recnumero",
          width: 70,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "recfecha",
          width: 80,
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "recnombre",
          width: 250,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "recdetalle",
          width: 320,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "recimporte",
          width: 150,
        },
        /* {
            text: "Asiento",
            align: "center",
            sortable: true,
            value: "asinumero",
            width: 100
          }, */
        {
          text: "CAE",
          align: "center",
          sortable: true,
          value: "cae",
          width: 90,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "recestado",
          width: 110,
        },
      ],
      reciboseleccionado: [],
      listapuntosventa: [],
      listatiposrecibos: [
        { idtiporecibo: -1, tiporecibo: "(TODOS)" },
        { idtiporecibo: 1, tiporecibo: "Matriculados (CC)" },
        { idtiporecibo: 2, tiporecibo: "Fondos Fijos" },
        { idtiporecibo: 3, tiporecibo: "Otros Ingresos" },
        { idtiporecibo: 4, tiporecibo: "Matriculados (Otros Conceptos)" },
        { idtiporecibo: 5, tiporecibo: "Activ. Académicas" },
      ],
      dialognuevorecibo: false,
      listatalonarios: [],
      recibo: {
        idpuntoventa: '',
        idpersona: 0,
        persona: '',
        nromatriculado: 0,
        fecha: this.fechaFormatoVmenu(new Date()), //new Date().toLocaleDateString('en-CA'),
        itemsdebe: [],
        itemssaldofavor: [],
        itemsdescuentos: [],
        montorecibo: 0,
        montoapagar: 0,
        montodescuentos: 0,
        itemsabonos: [
          {
            idformapago: 10,
            descripcion: "EFECTIVO (CAJA)",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 2,
            descripcion: "CHEQUES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 12,
            descripcion: "DEPOSITO BANCARIO",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 6,
            descripcion: "TRANSFERENCIAS BANCARIAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 9,
            descripcion: "DOLARES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 11,
            descripcion: "OTRAS CUENTAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 99,
            descripcion: "HABER CC",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
        ],
        usuario: '',
        titulo: '',
        cuitpersona: '',
        idcondicionivapersona: 0,
        relevardatosfiscales: false,
        selcondicioniva: 2
      },
      itemdebeseleccionado: [],
      columnasdebe: [
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "numero",
          width: 20,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 200,
        },
        {
          text: "Importe Total",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        },
        {
          text: "Interes",
          align: "center",
          sortable: true,
          value: "interes",
          width: 110,
        },
        {
          text: "Imputa",
          align: "center",
          sortable: true,
          value: "imputa",
          width: 110,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      columnasdebeconsulta: [
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "numero",
          width: 20,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 150,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 90,
        },
        {
          text: "Int.",
          align: "center",
          sortable: true,
          value: "interes",
          width: 90,
        },
        {
          text: "Imputa",
          align: "center",
          sortable: true,
          value: "imputa",
          width: 90,
        },
      ],
      columnassaldofavor: [
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "idsaldofavor",
          width: 20,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 200,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        },
      ],
      itemdescuentoseleccionado: [],
      columnasdescuentos: [
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "iddescuento",
          width: 20,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 200,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      columnasabonos: [
        {
          text: "Forma Pago",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 300,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 120,
        },
      ],
      dialognuevoitemdebe: false,
      itemsccmatseleccionado: [],
      columnasccmatriculado: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmovimientocc",
          width: 20,
        },
        {
          text: "N° Comp",
          align: "center",
          sortable: true,
          value: "nrocomprobante",
          width: 30,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 200,
        },
        {
          text: "Vencim.",
          align: "center",
          sortable: true,
          value: "vencimientostrdmy",
          width: 110,
        },
        {
          text: "Fec. Int",
          align: "center",
          sortable: true,
          value: "fechainteresstrdmy",
          width: 110,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 80,
        },
        {
          text: "Imp. UHON",
          align: "center",
          sortable: true,
          value: "importevalorreferencia",
          width: 80,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 80,
        },
        {
          text: "Saldo UHON",
          align: "center",
          sortable: true,
          value: "saldovalorreferencia",
          width: 100,
        },
        {
          text: "Interes",
          align: "center",
          sortable: true,
          value: "interes",
          width: 80,
        },
        {
          text: "Total",
          align: "center",
          sortable: true,
          value: "total",
          width: 100,
        },
      ],
      listaccmatriculado: [],
      itemabonoseleccionado: [],
      menufintCC: false,
      fechainteresCC: "",
      nuevoitemdebe: {
        numero: 0,
        codigo: "",
        descripcion: "",
        importe: 0,
      },
      nuevoitemdesc: {
        numero: 0,
        codigo: "",
        descripcion: "",
        importe: 0,
      },
      tabactivofp: "Totales",
      dialogformaspagos: false,
      rec_fp_efe_nrocomp: 0,
      rec_fp_efe_idcuenta: "",
      rec_fp_efe_detalle: "",
      rec_fp_efe_importe: 0,
      listacuentasbancarias: [],
      columnasfpefecomp: [
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "nro",
          width: 50,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 250,
        },
        {
          text: "Cuenta",
          align: "center",
          sortable: true,
          value: "cuenta",
          width: 150,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 100,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      menufcheq: false,
      menufcheqvenc: false,
      rec_fp_cheq_banco: "",
      rec_fp_cheq_nrocheq: "",
      rec_fp_cheq_fecha: "",
      rec_fp_cheq_vencimiento: "",
      rec_fp_cheq_alaorden: false,
      rec_fp_cheq_importe: 0,
      columnasfpcheques: [
        {
          text: "Banco",
          align: "center",
          sortable: true,
          value: "banco",
          width: 250,
        },
        {
          text: "N° Cheque",
          align: "center",
          sortable: true,
          value: "nro",
          width: 120,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fecha",
          width: 110,
        },
        {
          text: "Vencim.",
          align: "center",
          sortable: true,
          value: "vencimiento",
          width: 110,
        },
        {
          text: "A la orden",
          align: "center",
          sortable: true,
          value: "alaorden",
          width: 110,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 100,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      columnasfpdepcomp: [
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "nro",
          width: 50,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 250,
        },
        {
          text: "Cuenta",
          align: "center",
          sortable: true,
          value: "cuenta",
          width: 150,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 100,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      rec_fp_dep_nrocomp: 0,
      rec_fp_dep_idcuenta: "",
      rec_fp_dep_detalle: "",
      rec_fp_dep_importe: 0,
      columnasfptracomp: [
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "nro",
          width: 50,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 250,
        },
        {
          text: "Cuenta",
          align: "center",
          sortable: true,
          value: "cuenta",
          width: 150,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 100,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      rec_fp_tra_nrocomp: 0,
      rec_fp_tra_idcuenta: "",
      rec_fp_tra_importe: 0,
      rec_fp_tra_detalle: "",
      columnasfpOC: [
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "nrostr",
          width: 20,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 200,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        },
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
      ],
      rec_fp_ocu_idcuenta: 0,
      rec_fp_ocu_numero: 0,
      rec_fp_ocu_codigo: "",
      rec_fp_ocu_descripcion: "",
      rec_fp_ocu_importe: 0,
      recibooriginal: {},
      pagounico: false,
      cuotaanualactual: {},
      catanttitulo: 0,
      menufrec: false,
      columnasfphcccomp: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmovimientocc",
          width: 20,
        },
        {
          text: "N° Comp",
          align: "center",
          sortable: true,
          value: "nrocomprobante",
          width: 30,
        },
        {
          text: "Detalle",
          align: "center",
          sortable: true,
          value: "detalle",
          width: 200,
        },
        {
          text: "Vencim.",
          align: "center",
          sortable: true,
          value: "vencimiento",
          width: 110,
        },
        {
          text: "Fec. Int",
          align: "center",
          sortable: true,
          value: "fechainteres",
          width: 110,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 80,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 80,
        },
        {
          text: "Imputa",
          align: "center",
          sortable: true,
          value: "imputa",
          width: 80,
        },
      ],
      listacchabermatriculado: [],
      dialogverexportar: false,
      listaformatos: [{ formato: "PDF" }, { formato: "EXCEL" }],
      formatosel: "PDF",
      dialogrecibomanual: false,
      cambiomanual: {
        idpuntoventaactual: "",
        puntoventaactual: "",
        idpuntoventanuevo: "",
        proxnumerorecibo: "",
      },
      listapuntosventamanual: [],
      iddelegacionusuario: 0,
      verdebeenfp: false,
      rec_desc_idtipodescuento: 1,
      rec_desc_concepto: "",
      rec_desc_importe: 0.0,
      rec_desc_porcentaje: 0.0,
      listatiposdescuentos: [],
      dialogdescuento: false,
      estadopagounico: 0,
      estadopagounicomensaje: "",
      listadeudafp: [],
      columnasdeudafp: [
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 300,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 100,
        }
      ],
      rulesnrocomp: {
        counter: value => value.length <= 20 || 'Máx. 20 cifras'
      },
      listacondicionesiva: [],
      selcondicioniva: '2'
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    this.iddelegacionusuario = localStorage.getItem("iddelegacion");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var idrol= localStorage.getItem('rolusuario')
    var roles = localStorage.getItem("rolesusuario");
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error", "No tiene permisos para acceder a este módulo.", true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 9).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion > 1 && p.idaccion < 9).length > 0 ? true : false;
      this.CompletaCombos();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    actualizatalonario() {
      axios.get("talonariorecibo").then((result) => {
          var talonariosedit = result.data.slice();
          var roles = localStorage.getItem("rolesusuario");
          if (roles.includes(1) === false && roles.includes(2) === false) {
            talonariosedit = talonariosedit.filter(
              (t) => t.delegaciones.includes(this.iddelegacionusuario) === true
            );
          }
          this.listatalonarios = JSON.parse(JSON.stringify(talonariosedit));
          this.listapuntosventa = result.data;
          this.listapuntosventa.unshift({
            idpuntoventa: -1,
            puntoventa: "(TODOS)",
          });
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    CompletaCombos() {
      this.loading = true;
      this.actualizatalonario();
    },
    ListarRecibos(mensaje) {
      this.loading = true;
      var fecdesde =
        this.filtros.desde != "" && this.filtros.desde != null
          ? this.filtros.desde
          : " ";
      var fechasta =
        this.filtros.hasta != "" && this.filtros.hasta != null
          ? this.filtros.hasta
          : " ";
      var recdesde =
        this.filtros.recibodesde != "" && this.filtros.recibodesde != null
          ? this.filtros.recibodesde
          : 0;
      var rechasta =
        this.filtros.recibohasta != "" && this.filtros.recibohasta != null
          ? this.filtros.recibohasta
          : 0;
      var nombre =
        this.filtros.nombre != "" && this.filtros.nombre != null
          ? this.filtros.nombre
          : " ";
      var idtiporec =
        this.filtros.idtiporecibo != "" &&
        this.filtros.idtiporecibo != null &&
        this.filtros.idtiporecibo != -1
          ? this.filtros.idtiporecibo
          : 0;
      var idptoventa =
        this.filtros.idpuntoventa != "" &&
        this.filtros.idpuntoventa != null &&
        this.filtros.idpuntoventa != -1
          ? this.filtros.idpuntoventa
          : 0;
      var detalle =
        this.filtros.detalle != "" && this.filtros.detalle != null
          ? this.filtros.detalle
          : " ";
      axios
        .get(
          "tesoreria/ListaABMRecibo/" +
            fecdesde +
            "/" +
            fechasta +
            "/" +
            nombre +
            "/" +
            detalle +
            "/" +
            recdesde +
            "/" +
            rechasta +
            "/" +
            idtiporec +
            "/" +
            idptoventa
        )
        .then((result) => {
          this.listarecibos = result.data;
          if (mensaje.length > 0) {
            this.actualizatalonario();
            this.MostrarMensaje("Error", mensaje, false);
          } else {
            this.actualizatalonario();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    NuevoRecibo() {
      this.loading = true;
      this.tituloabm = "Nuevo Recibo";
      this.nuevoitemdebe.numero = 0;
      this.nuevoitemdebe.codigo = "";
      this.nuevoitemdebe.descripcion = "";
      this.nuevoitemdebe.importe = 0;
      this.nuevoitemdesc.numero = 0;
      this.nuevoitemdesc.codigo = "";
      this.nuevoitemdesc.descripcion = "";
      this.nuevoitemdesc.importe = 0;
      if (this.$refs.selpersonarecibo != null) {
        this.$refs.selpersonarecibo.QuitarFiltroPersona();
      }
      this.recibo = {
        idpuntoventa: "",
        idpersona: 0,
        persona: "",
        nromatriculado: 0,
        fecha: this.fechaFormatoVmenu(new Date()), //new Date().toLocaleDateString('en-CA'),
        itemsdebe: [],
        itemssaldofavor: [],
        itemsdescuentos: [],
        montorecibo: 0,
        montoapagar: 0,
        montodescuentos: 0,
        itemsabonos: [
          {
            idformapago: 10,
            descripcion: "EFECTIVO (CAJA)",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 2,
            descripcion: "CHEQUES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 12,
            descripcion: "DEPOSITO BANCARIO",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 6,
            descripcion: "TRANSFERENCIAS BANCARIAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 9,
            descripcion: "DOLARES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 11,
            descripcion: "OTRAS CUENTAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 99,
            descripcion: "HABER CC",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
        ],
        usuario: this.usuario,
        titulo: "",
        cuitpersona: '',
        idcondicionivapersona: 0,
        relevardatosfiscales: false,
        selcondicioniva: 2
      };
      this.selcondicioniva= '2';
      this.itemsccmatseleccionado = [];
      this.itemdebeseleccionado = [];
      this.itemdescuentoseleccionado = [];
      this.itemabonoseleccionado = [];
      this.relevardatosfiscales= false;
      this.actualizatalonario();
      axios.get("parametrosistema/10").then((result) => {
        var valor = result.data.toString().replace(",", ".");
        this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].valordolar = valor;
        axios.get("referenciales/tiposdescuentosrecibo").then((result) => {
          this.listatiposdescuentos = result.data;
          axios.get("referenciales/condicioniva").then((result) => {
            this.listacondicionesiva = result.data;
            this.dialognuevorecibo = true;
            this.loading = false;
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    GrabarNuevoRecibo() {
      this.loading = true;
      this.recibo.selcondicioniva= parseInt(this.selcondicioniva);
      var valida = this.ValidaDatosRecibo();
      if (valida === "OK") {
        const recibo = JSON.stringify(this.recibo);
        axios.post("tesoreria/PostRecibo", recibo, { headers: { "Content-Type": "application/json" }}).then((result) => {
          var d = result.data;
          if (d.resultadogeneral === 0) {
            this.dialognuevorecibo = false;
            this.PreguntarExportar(d.resultadorecibonro.toString(),d.resultadoreciboid,d.resultadoafipcae,true);
          } else {
            var mensaje = "";
            var reciboid = "";
            var reciboguardado = false;
            if (d.resultadogeneral === 1) {
              //Error al generar recibo en BD
              reciboid = d.resultadoreciboid != -1 ? " - Recibo Nro: " +d.resultadorecibonro.toString()+" (ID "+d.resultadoreciboid.toString()+")" : "";
              mensaje = "Error al guardar recibo: "+d.resultadorecibobdmensaje+reciboid;
            } else if (d.resultadogeneral === 2) {
              //OK generar recibo en BD pero Error al intentar informar al AFIP el recibo
              reciboguardado = true;
              mensaje = "El Recibo Nro: "+d.resultadorecibonro.toString()+"(ID "+d.resultadoreciboid.toString()+") fue guardado con éxito pero hubo un error al ser informado al AFIP. Deberá informar el recibo desde la grilla o imprimir el recibo manualmente. Error: "+d.resultadoafip.toString()+"-"+d.resultadoafipmensaje;
            } else if (d.resultadogeneral === 3) {
              //Error general del proceso (catch)
              reciboid = d.resultadoreciboid != -1 ? " - Recibo Nro: "+d.resultadorecibonro.toString()+" (ID "+d.resultadoreciboid.toString()+")" : "";
              mensaje = "Error del sistema, Informe a Sistemas. "+reciboid+" - Detalle del Error: "+d.resultadogeneralmensaje+". Error BD: "+d.resultadorecibobdmensaje+". Error AFIP: "+d.resultadoafipmensaje;
            }
            if (reciboguardado === false) {
              this.loading = false;
              this.MostrarMensaje("Error", mensaje, false);
            } else {
              this.dialognuevorecibo = false;
              this.ListarRecibos(mensaje);
            }
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", valida, false);
      }
    },
    async InformaAFIP() {
      if (this.reciboseleccionado[0].pvtipo <= 2) {
        if (await this.$refs.confirm.open("Informar Recibo","Está seguro que desea informar al AFIP el recibo?")) {
          this.loading = true;
          var rec = { idrecibo: this.reciboseleccionado[0].recibo, usuario: this.usuario };
          axios.put("tesoreria/PutReciboInformarAFIP", rec, { headers: { "Content-Type": "application/json"}}).then((result) => {
            var d = result.data;
            if (d.resultadogeneral === 0) {
              this.reciboseleccionado = [];
              this.ListarRecibos("");
            } else {
              var mensaje = "";
              var reciboid = "";
              if (d.resultadogeneral === 2) {
                //Error al intentar informar al AFIP el recibo
                mensaje = "Hubo un error con el Recibo Nro: " +d.resultadorecibonro.toString() +"(ID " +d.resultadoreciboid.toString() +")  al ser informado al AFIP. Error: " +d.resultadoafip.toString() +"-" +d.resultadoafipmensaje;
              } else if (d.resultadogeneral === 3) {
                //Error general del proceso (catch)
                reciboid = d.resultadoreciboid != -1 ? " - Recibo Nro: " +d.resultadorecibonro.toString() +" (ID " +d.resultadoreciboid.toString() +")" : "";
                mensaje = "Error del sistema, Informe a Sistemas. " +reciboid +" - Detalle del Error: " +d.resultadogeneralmensaje +". Error BD: " +d.resultadorecibobdmensaje +". Error AFIP: " +d.resultadoafipmensaje;
              }
              this.loading = false;
              this.MostrarMensaje("Error", mensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", "Punto de Venta Incorrecto", false);
      }
    },
    ReciboManual() {
      this.listapuntosventamanual = this.listapuntosventa
        .slice()
        .filter((p) => p.idtipo === 1);
      this.cambiomanual = {
        idpuntoventaactual: this.reciboseleccionado[0].recpvta,
        puntoventaactual: this.listapuntosventa.filter(
          (p) => p.idpuntoventa === this.reciboseleccionado[0].recpvta
        )[0].puntoventa,
        idpuntoventanuevo:
          this.listapuntosventamanual.length > 0
            ? this.listapuntosventamanual[0].idpuntoventa
            : "",
        proxnumerorecibo:
          this.listapuntosventamanual.length > 0
            ? parseInt(this.listapuntosventamanual[0].ultnrorecibo) + 1
            : "",
      };
      this.dialogrecibomanual = true;
    },
    async CambiarReciboManual() {
      this.loading = true;
      if (
        await this.$refs.confirm.open(
          "Cambiar Punto de Venta",
          "Está seguro que desea cambiar el punto de venta del recibo:?"
        )
      ) {
        var rec = {
          idrecibo: this.reciboseleccionado[0].recibo,
          idpuntoventa: this.cambiomanual.idpuntoventanuevo,
          numerocomp: this.cambiomanual.proxnumerorecibo,
          usuario: this.usuario,
        };
        axios
          .put("tesoreria/PutReciboCambioPV", rec, {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          })
          .then((result) => {
            if (result.data.resultado === 0) {
              this.dialogrecibomanual = false;
              this.ListarRecibos("");
            } else {
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      } else {
        this.loading = false;
      }
    },
    async PreguntarExportar(nro, idrecibo, cae, actualizagrilla) {
      if (
        await this.$refs.confirm.open(
          "Recibo Generado!!!",
          "Fue generado el Recibo Nº " +
            nro +
            ". Desea ver o exportar el mismo?"
        )
      ) {
        // exportar pdf orden de pago
        this.exportarRecibo(idrecibo, cae, actualizagrilla);
      } else {
        this.loading = false;
      }
    },
    ValidaDatosRecibo() {
      var valido = "OK";
      var i = 0;
      this.recibo.montorecibo= parseFloat(parseFloat(this.recibo.montorecibo).toFixed(2));
      this.recibo.montoapagar= parseFloat(parseFloat(this.recibo.montoapagar).toFixed(2));
      this.recibo.montodescuentos= parseFloat(parseFloat(this.recibo.montodescuentos).toFixed(2));
      for (i = 0; i < this.recibo.itemsdebe.length; i++) {
        this.recibo.itemsdebe[i].imputa = parseFloat(this.recibo.itemsdebe[i].imputa);
        /* if (this.recibo.itemsdebe[i].imputa < parseFloat(this.recibo.itemsdebe[i].interes)) {
          valido = "En la grilla de detalles del recibo hay items donde el monto a imputar es menor que el monto de interes.";
        } */
      }
      i = 0;
      for (i = 0; i < this.recibo.itemssaldofavor.length; i++) {
        this.recibo.itemssaldofavor[i].importe = parseFloat(this.recibo.itemssaldofavor[i].importe);
      }
      i = 0;
      for (i = 0; i < this.recibo.itemsdescuentos.length; i++) {
        this.recibo.itemsdescuentos[i].importe = parseFloat(this.recibo.itemsdescuentos[i].importe);
      }
      if (valido === 'OK') {
        if (this.recibo.idpuntoventa === null || this.recibo.idpuntoventa === "") {
          valido = "Debe seleccionar punto de venta!!!";
        }
        if (this.recibo.idpersona === null || this.recibo.idpersona === "") {
          valido = "Debe seleccionar persona!!!";
        }
        if (this.recibo.relevardatosfiscales===true){
          if(this.recibo.selcondicioniva===2){
            if (this.recibo.cuitpersona === null || this.recibo.cuitpersona === "") {
              valido = "La persona no tiene CUIT y debe ingresarlo en el cuadro que corresponde!!!";
            }
            if (this.recibo.idcondicionivapersona === null || this.recibo.idcondicionivapersona === 0) {
              valido = "La persona no tiene su condición de iva y debe seleccionarlo en el combo que corresponde!!!";
            }
          }else{
            if (this.recibo.idcondicionivapersona != null && this.recibo.idcondicionivapersona != 0){
              valido = "La persona tiene su condición de iva por lo cual NO debe emitir el recibo como consumidor final!!!";
            }
          }
        }
        if (this.recibo.fecha === null || this.recibo.fecha === "") {
          valido = "Debe seleccionar fecha de la venta!!!";
        }
        if (this.recibo.itemsdebe.length === 0) {
          valido = "Debe ingresar items a cobrar para al recibo!!!";
        }
        /*if (this.recibo.montorecibo - this.recibo.montodescuentos != this.recibo.montoapagar) {
          valido = "El monto total de las formas de pago no es igual al monto a cobrar del recibo!!!";
        }*/
        if (this.recibo.itemsdebe.filter((f) => f.imputa <= 0).length > 0) {
          valido = "En la grilla de detalles del recibo hay items sin imputar, borre los mismos o ingrese los montos a imputar!!!";
        }
      }
      return valido;
    },
    async AbreCuadroAnularRecibo() {
      if (await this.$refs.confirm.open("Anular Recibo", "Está seguro de anular el recibo " + this.reciboseleccionado[0].recnumero + "?")) {
        this.loading = true;
        var rec = { idrecibo: this.reciboseleccionado[0].recibo, usuario: this.usuario };
        axios.put("tesoreria/PutReciboAnular", rec, {
            headers: {
              "Content-Type": "application/json",
            },
          }).then((result) => {
            var d = result.data;
            if (d.resultadogeneral === 0) {
              this.reciboseleccionado = [];
              this.ListarRecibos("");
            } else {
              var mensaje = "";
              var reciboid = "";
              var reciboguardado = false;
              if (d.resultadogeneral === 1) {
                //Error al generar recibo en BD
                reciboid = d.resultadoreciboid != -1 ? " - Nota de Cred Nro: " + d.resultadorecibonro.toString() + " (ID " + d.resultadoreciboid.toString() + ")" : "";
                mensaje = "Error al guardar nota de credito: " + d.resultadorecibobdmensaje + reciboid;
              } else if (d.resultadogeneral === 2) {
                //OK generar recibo en BD pero Error al intentar informar al AFIP el recibo
                reciboguardado = true;
                mensaje = "La Nota de Crédito Nro: " + d.resultadorecibonro.toString() + "(ID " + d.resultadoreciboid.toString() + ") fue guardada con éxito y el recibo anulado en el sistema pero hubo un error al ser informada la nota de crédito al AFIP. Informar a Sistemas. Error: " + d.resultadoafip.toString() + "-" + d.resultadoafipmensaje;
              } else if (d.resultadogeneral === 3) {
                //Error general del proceso (catch)
                reciboid = d.resultadoreciboid != -1 ? " - Nota de Cred. Nro: " + d.resultadorecibonro.toString() + " (ID " + d.resultadoreciboid.toString() + ")" : "";
                mensaje = "Error del sistema, Informe a Sistemas. " + reciboid + " - Detalle del Error: " + d.resultadogeneralmensaje + ". Error BD: " + d.resultadorecibobdmensaje + ". Error AFIP: " + d.resultadoafipmensaje;
              }
              if (reciboguardado === false) {
                this.loading = false;
                this.MostrarMensaje("Error", mensaje, false);
              } else {
                this.ListarRecibos(mensaje);
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    AbrirCuadroReImprimir() {
      this.loading = true;
      this.exportarRecibo(this.reciboseleccionado[0].recibo, this.reciboseleccionado[0].cae, false);
    },
    exportarRecibo(idrecibo, cae, actualizagrilla) {
      this.loading = true;
      var idrep = cae != null && cae.length > 0 ? 22 : 7;
      axios
        .post(
          "reportes/GetReporte",
          {
            idreporte: idrep,
            formato: "PDF",
            listaparametros: [
              { orden: 1, nombre: "idrecibo", valor: idrecibo.toString() },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
            if (actualizagrilla === true) {
              this.ListarRecibos("");
            }
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    AbrirCuadroImprimirExportar() {
      this.dialogverexportar = true;
    },
    exportarlistado() {
      this.loading = true;
      var fecdesde =
        this.filtros.desde != "" && this.filtros.desde != null
          ? this.filtros.desde
          : " ";
      var fechasta =
        this.filtros.hasta != "" && this.filtros.hasta != null
          ? this.filtros.hasta
          : " ";
      var recdesde =
        this.filtros.recibodesde != "" && this.filtros.recibodesde != null
          ? this.filtros.recibodesde
          : "0";
      var rechasta =
        this.filtros.recibohasta != "" && this.filtros.recibohasta != null
          ? this.filtros.recibohasta
          : "0";
      var nombre =
        this.filtros.nombre != "" && this.filtros.nombre != null
          ? this.filtros.nombre
          : " ";
      var idptoventa =
        this.filtros.idpuntoventa != "" &&
        this.filtros.idpuntoventa != null &&
        this.filtros.idpuntoventa != -1
          ? this.filtros.idpuntoventa
          : "0";
      var detalle =
        this.filtros.detalle != "" && this.filtros.detalle != null
          ? this.filtros.detalle
          : " ";
      axios
        .post(
          "reportes/GetReporte",
          {
            idreporte: 6,
            formato: this.formatosel,
            listaparametros: [
              { orden: 1, nombre: "fecdesde", valor: fecdesde },
              { orden: 2, nombre: "fechasta", valor: fechasta },
              { orden: 3, nombre: "recdesde", valor: recdesde },
              { orden: 4, nombre: "rechasta", valor: rechasta },
              { orden: 5, nombre: "nombre", valor: nombre },
              { orden: 6, nombre: "idptoventa", valor: idptoventa },
              { orden: 7, nombre: "detalle", valor: detalle },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    BuscaItemDebeCC() {
      this.loading = true;
      this.fechainteresCC = this.fechaFormatoVmenu(new Date()); //new Date().toLocaleDateString('en-CA')
      this.itemsccmatseleccionado = [];
      this.pagounico = false;
      if (this.recibo.idpersona != null && this.recibo.idpersona != "") {
        if (this.recibo.nromatriculado != 0) {
          this.ListarCCMatriculado();
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", "debe seleccionar un matriculado!!!", false);
        }
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", "Falta Seleccionar la Persona!!!", false);
      }
    },
    ListarCCMatriculado() {
      //var fechaconsulta=this.fechainteresCC.toLocaleDateString('en-CA').replace('/','-').replace('/','-')
      axios.get("CCMatriculado/CCListaDRecibo/" + this.fechainteresCC + "/" + this.recibo.idpersona).then((result) => {
          this.listaccmatriculado = result.data[0];
          this.cuotaanualactual = result.data[1];
          this.catanttitulo = result.data[2];
          this.dialognuevoitemdebe = true;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    //   BuscaItemDebeAA () {

    //   },
    SeleccionarItemsDebe() {
      this.recibo.itemsdebe = [];
      if (this.itemsccmatseleccionado.length > 0) {
        this.loading = true;
        var iddebe = 0;
        this.itemsccmatseleccionado.forEach((item) => {
          iddebe = this.recibo.itemsdebe.length > 0 ? this.recibo.itemsdebe[this.recibo.itemsdebe.length - 1].iddebe : 1;
          this.recibo.itemsdebe.push({
            idtipomov: 1,
            idmovimientocc: item.idmovimientocc,
            iddebe: iddebe,
            numero: parseInt(item.numerocomprobante),
            concepto: item.detalle,
            importe: parseFloat(item.total),
            imputa: parseFloat(item.total),
            cuotaanual: item.cuotaanual,
            cuotanro: item.cuotanro,
            vencimiento: item.vencimientostr,
            fechainteres: item.fechainteresstr,
            interes: item.interes,
            idcuenta: item.idcuenta,
            idcuentainteres: item.idcuentainteres,
            idcuentaejeanterior: item.idcuentaejeanterior,
            idcurso: item.idcurso,
            idtarifacurso: item.idtarifacurso,
            idcuentacurso: item.idcuentacurso,
            idtipocuota: item.idtipocuota,
            fechacalculointeres: this.fechainteresCC
          });
        });
        this.dialognuevoitemdebe = false;
        if (this.recibo.montoapagar > 0) {
          this.Imputaautomatico();
        }
        //buscar si esta en condiciones de pagar con descuento por pago unico
        if(this.recibo.itemsdebe.length>0){
          this.ControlaPagoUnico(this.recibo.itemsdebe,this.fechainteresCC,this.recibo.idpersona);
        }
      }
    },
    AgregaNuevoItemDebe() {
      if (this.nuevoitemdebe.numero != "" || this.nuevoitemdebe.numero != 0) {
        if (this.nuevoitemdebe.importe > 0) {
          this.loading = true;
          var iddebe = 0;
          iddebe = this.recibo.itemsdebe.length > 0 ? this.recibo.itemsdebe[this.recibo.itemsdebe.length - 1].iddebe : 1;
          this.recibo.itemsdebe.push({
            idtipomov: 2,
            idmovimientocc: -1,
            iddebe: iddebe,
            numero: parseInt(this.nuevoitemdebe.numero),
            concepto: "(" + this.nuevoitemdebe.codigo + ") - " + this.nuevoitemdebe.descripcion,
            importe: parseFloat(this.nuevoitemdebe.importe),
            imputa: parseFloat(this.nuevoitemdebe.importe),
            cuotaanual: 0,
            cuotanro: 0,
            vencimiento: "",
            fechainteres: "",
            interes: 0,
            idcuenta: 0,
            idcuentainteres: 0,
            idcuentaejeanterior: 0,
            idcurso: 0,
            idtarifacurso: 0,
            idcuentacurso: 0,
            idtipocuota: 0,
            fechacalculointeres: ''
          });
          this.nuevoitemdebe.numero = "";
          this.nuevoitemdebe.codigo = "";
          this.nuevoitemdebe.descripcion = "";
          this.nuevoitemdebe.importe = 0;
          if (this.recibo.montoapagar > 0) {
            this.Imputaautomatico();
          }
          if(this.$refs.selcuentarecibo!=null){
            this.$refs.selcuentarecibo.QuitarCuenta();
          }
          this.loading = false;
        } else {
          this.MostrarMensaje("Error", "Debe ingresar un importe válido!",false);
        }
      } else {
        this.MostrarMensaje("Error", "Debe seleccionar la cuenta!", false);
      }
    },
    async QuitarItemDebe(item) {
      if (
        await this.$refs.confirm.open(
          "Confirmar Borrado",
          "Esta seguro de querer quitar el registro?"
        )
      ) {
        this.loading = false;
        this.recibo.itemsdebe.splice(this.recibo.itemsdebe.indexOf(item), 1);
        if (this.recibo.montoapagar > 0) {
          this.Imputaautomatico();
        }
        if(this.recibo.itemsdebe.length>0){
          this.ControlaPagoUnico(this.recibo.itemsdebe,this.fechainteresCC,this.recibo.idpersona);
        }
      }
    },
    ControlaPagoUnico (deuda, fechainteres, idpersona) {
        var dataacontrolar = {
          deudaseleccionada: deuda,
          fechainteres: fechainteres,
          idpersona: idpersona,
        };
        var i = 0;
        for (i = 0; i < dataacontrolar.deudaseleccionada.length; i++) {
            dataacontrolar.deudaseleccionada[i].imputa = parseFloat(dataacontrolar.deudaseleccionada[i].imputa);
        }
        const datoscontrol = JSON.stringify(dataacontrolar);
        axios
          .post("ccmatriculado/PostChequeaPagoUnico", datoscontrol, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((result) => {
            this.estadopagounico = result.data.id;
            this.estadopagounicomensaje = result.data.resultadoMensaje;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.estadopagounico= 1;
            this.estadopagounicomensaje = 'Error';
            this.MostrarMensaje("Error", error, false);
          });
    },
    /* AgregaNuevoItemDesc () {
        this.loading= true
        var iddescuento=0;
        iddescuento=this.recibo.itemsdescuentos.length>0 ? this.recibo.itemsdescuentos[this.recibo.itemsdescuentos.length-1].iddescuento : 1;
        this.recibo.itemsdescuentos.push({idtipomov: 2, iddescuento: iddescuento , numero: this.nuevoitemdesc.numero + ' (' + this.nuevoitemdesc.codigo + ')', concepto: this.nuevoitemdesc.descripcion, importe: this.nuevoitemdesc.importe})
        this.nuevoitemdesc.numero=0
        this.nuevoitemdesc.codigo=''
        this.nuevoitemdesc.descripcion=''
        this.nuevoitemdesc.importe=0
        this.loading= false
      },
      async QuitarItemDesc (item) {
        if (await this.$refs.confirm.open('Confirmar Borrado', 'Esta seguro de querer quitar el registro?')) {
          this.recibo.itemsdescuentos.splice(this.recibo.itemsdescuentos.indexOf(item), 1)
        }
      }, */
    BuscarCuenta() {
      if (this.nuevoitemdebe.numero > 0) {
        axios
          .get("cuenta/" + this.nuevoitemdebe.numero)
          .then((result) => {
            // this.listaestadostramitesfiltro = result.data;
            if (result.data.length > 0) {
              var dato = result.data[0];
              this.nuevoitemdebe.codigo = dato.codigo;
              this.nuevoitemdebe.descripcion = dato.descripcion;
            } else {
              this.loading = false;
              this.MostrarMensaje(
                "Error",
                "El codigo ingresado no existe!!!",
                false
              );
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    BuscarCuentaFPOC() {
      if (this.rec_fp_ocu_numero > 0) {
        axios
          .get("cuenta/" + this.rec_fp_ocu_numero)
          .then((result) => {
            if (result.data.length > 0) {
              var dato = result.data[0];
              this.rec_fp_ocu_idcuenta = dato.cuenta;
              this.rec_fp_ocu_codigo = dato.codigo;
              this.rec_fp_ocu_descripcion = dato.descripcion;
            } else {
              this.loading = false;
              this.MostrarMensaje(
                "Error",
                "El codigo ingresado no existe!!!",
                false
              );
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    asignapersona(value) {
      this.recibo.idpersona = value != null ? value.idpersona : "";
      this.recibo.persona = value != null ? value.apenom : "";
      this.recibo.nromatriculado = value != null ? value.nromatriculadosisant != null ? value.nromatriculadosisant : 0 : 0;
      this.recibo.idcondicionivapersona = value != null ? value.idcondicioniva!=null ? value.idcondicioniva : 0 : 0;
      this.recibo.cuitpersona = value != null ? value.cuit!=null ? value.cuit : '' : '';
      if(this.recibo.idpersona!=0 && (this.recibo.cuitpersona.length===0 || this.recibo.idcondicionivapersona===0)){
        this.recibo.relevardatosfiscales=true;
        this.recibo.selcondicioniva=2;
        this.selcondicioniva='2';
      }else{
        this.recibo.relevardatosfiscales=false;
        this.recibo.selcondicioniva=2;
        this.selcondicioniva='2';
      }
      this.recibo.itemsdebe = [];
    },
    sumamontorecibo() {
      var suma = 0;
      var i = 0;
      for (i = 0; i < this.recibo.itemsdebe.length; i++) {
        suma += parseFloat(this.recibo.itemsdebe[i].imputa);
      }
      /* for(i=0;i<this.recibo.itemsdescuentos.length;i++)
        {
            suma-= parseFloat(this.recibo.itemsdescuentos[i].importe);
        } */
      this.recibo.montorecibo = suma;
      return suma.toFixed(2);
    },
    sumamontopagos() {
      var sumapagos = 0;
      var i = 0;
      for (i = 0; i < this.recibo.itemsabonos.length; i++) {
        sumapagos += parseFloat(this.recibo.itemsabonos[i].importe);
      }
      this.recibo.montoapagar = sumapagos;
      return sumapagos.toFixed(2);
    },
    sumamontodescuentos() {
      var sumapagos = 0;
      var i = 0;
      for (i = 0; i < this.recibo.itemsdescuentos.length; i++) {
        sumapagos += parseFloat(this.recibo.itemsdescuentos[i].importe);
      }
      this.recibo.montodescuentos = sumapagos;
      return sumapagos.toFixed(2);
    },
    ModificarPagos() {
      if (this.recibo.idpersona != null && this.recibo.idpersona != "") {
        this.actualizalistadeudafp();
        axios.get("cuentabancaria").then((result) => {
          this.listacuentasbancarias = result.data;
          this.rec_fp_efe_detalle = "";
          this.rec_fp_efe_idcuenta = "";
          this.rec_fp_efe_nrocomp = 0;

          this.recibooriginal = JSON.parse(JSON.stringify(this.recibo));

          //.get("ccmatriculado/CCListaHRecibo/" + (new Date()).toLocaleDateString('en-CA') + "/" + this.recibo.idpersona)

          axios.get("ccmatriculado/CCListaHRecibo/" +this.fechaFormatoVmenu(new Date()) +"/" +this.recibo.idpersona).then((result) => {
            this.listacchabermatriculado = result.data;
            this.dialogformaspagos = true;
            this.loading = false;
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      } else {
        this.MostrarMensaje("Error", "Debe seleccionar la persona!!!", false);
      }
    },
    AgregarCompEfectivo() {
      if (this.rec_fp_efe_nrocomp != null && this.rec_fp_efe_nrocomp > 0) {
        if(this.rec_fp_efe_nrocomp.length<=10){
          if (this.rec_fp_efe_detalle.length > 0) {
            if (this.rec_fp_efe_idcuenta != null && this.rec_fp_efe_idcuenta != "") {
              if(this.rec_fp_efe_importe!=null && this.rec_fp_efe_importe>0) {
                this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].registros.push({
                    banco: "",
                    nro: parseInt(this.rec_fp_efe_nrocomp),
                    nrostr: "",
                    fecha: "",
                    vencimiento: "",
                    alaorden: false,
                    detalle: this.rec_fp_efe_detalle,
                    idcuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_efe_idcuenta)[0].nrocuenta,
                    cuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_efe_idcuenta)[0].cuenta,
                    importe: parseFloat(this.rec_fp_efe_importe)
                });
                this.rec_fp_efe_nrocomp = 0;
                this.rec_fp_efe_idcuenta = "";
                this.rec_fp_efe_detalle = "";
                this.rec_fp_efe_importe = 0;
              } else {
                this.MostrarMensaje("Error","Debe ingresar el monto del mov de caja!!!",false);
              }
            } else {
              this.MostrarMensaje("Error","Debe seleccionar cuenta bancaria!!!",false);
            }
          } else {
            this.MostrarMensaje("Error","Debe ingresar detalle del comprobante!!!",false);
          }
        }else{
          this.MostrarMensaje("Error","El nro de comprobante no puede superar las 10 cifras!!!",false);
        }
      } else {
        this.MostrarMensaje("Error","Debe ingresar nro de comprobante!!!",false);
      }
    },
    async QuitarCompEfectivo(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].registros.splice(this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].registros.indexOf(item),1);
      }
    },
    AgregarCheque() {
      if (this.rec_fp_cheq_banco.length > 0) {
        if (this.rec_fp_cheq_nrocheq.length > 0) {
          if (this.rec_fp_cheq_fecha != null && this.rec_fp_cheq_fecha != "") {
            if (
              this.rec_fp_cheq_vencimiento != null &&
              this.rec_fp_cheq_vencimiento != ""
            ) {
              if (this.rec_fp_cheq_importe > 0) {
                this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].registros.push({
                    banco: this.rec_fp_cheq_banco,
                    nro: parseInt(this.rec_fp_cheq_nrocheq),
                    nrostr: "",
                    fecha: this.rec_fp_cheq_fecha,
                    vencimiento: this.rec_fp_cheq_vencimiento,
                    alaorden: this.rec_fp_cheq_alaorden,
                    detalle: "",
                    idcuenta: 0,
                    cuenta: "",
                    importe: this.rec_fp_cheq_importe,
                  });
                this.rec_fp_cheq_banco = "";
                this.rec_fp_cheq_nrocheq = "";
                this.rec_fp_cheq_fecha = "";
                this.rec_fp_cheq_vencimiento = "";
                this.rec_fp_cheq_alaorden = false;
                this.rec_fp_cheq_importe = 0;
              } else {
                this.MostrarMensaje("Error","Debe ingresar importe del cheque!!!",false);
              }
            } else {
              this.MostrarMensaje("Error","Debe ingresar fecha de vencimiento del cheque!!!",false);
            }
          } else {
            this.MostrarMensaje("Error","Debe ingresar fecha del cheque!!!",false);
          }
        } else {
          this.MostrarMensaje("Error","Debe ingresar nro del cheque!!!",false);
        }
      } else {
        this.MostrarMensaje("Error","Debe ingresar el banco emisor del cheque!!!",false);
      }
    },
    async QuitarCheque(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].registros.splice(this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].registros.indexOf(item),1);
      }
    },
    AgregarCompDeposito() {
      if (this.rec_fp_dep_nrocomp != null && this.rec_fp_dep_nrocomp > 0) {
        if (this.rec_fp_dep_nrocomp.length<=10){
          if (this.rec_fp_dep_detalle.length > 0) {
            if (this.rec_fp_dep_idcuenta != null && this.rec_fp_dep_idcuenta != "") {
              if(this.rec_fp_dep_importe!=null && this.rec_fp_dep_importe>0) {
                this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].registros.push({
                    banco: "",
                    nro: parseInt(this.rec_fp_dep_nrocomp),
                    nrostr: "",
                    fecha: "",
                    vencimiento: "",
                    alaorden: false,
                    detalle: this.rec_fp_dep_detalle,
                    idcuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_dep_idcuenta)[0].nrocuenta,
                    cuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_dep_idcuenta)[0].cuenta,
                    importe: parseFloat(this.rec_fp_dep_importe)
                });
                this.rec_fp_dep_nrocomp = 0;
                this.rec_fp_dep_idcuenta = "";
                this.rec_fp_dep_detalle = "";
                this.rec_fp_dep_importe = 0;
              } else {
                this.MostrarMensaje("Error","Debe ingresar el monto del depósito!!!",false);
              }
            } else {
                this.MostrarMensaje("Error","Debe seleccionar cuenta bancaria!!!",false);
            }
          } else {
            this.MostrarMensaje("Error","Debe ingresar detalle del comprobante!!!",false);
          }
        }else{
          this.MostrarMensaje("Error","El nro de comprobante debe tener como máximo 10 cifras!!!",false);
        }
      } else {
        this.MostrarMensaje("Error","Debe ingresar nro de comprobante!!!",false);
      }
    },
    async QuitarCompDeposito(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].registros.splice(this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].registros.indexOf(item),1);
      }
    },
    AgregarCompTransferencia() {
      if (this.rec_fp_tra_nrocomp != null && this.rec_fp_tra_nrocomp > 0) {
        if (this.rec_fp_tra_nrocomp.length<=10) {
            if (this.rec_fp_tra_detalle.length > 0) {
              if (this.rec_fp_tra_idcuenta != null && this.rec_fp_tra_idcuenta != "") {
                if(this.rec_fp_tra_importe!=null && this.rec_fp_tra_importe>0) {
                  this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].registros.push({
                      banco: "",
                      nro: parseInt(this.rec_fp_tra_nrocomp),
                      nrostr: "",
                      fecha: "",
                      vencimiento: "",
                      alaorden: false,
                      detalle: this.rec_fp_tra_detalle,
                      idcuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_tra_idcuenta)[0].nrocuenta,
                      cuenta: this.listacuentasbancarias.filter((c) => c.idcuenta === this.rec_fp_tra_idcuenta)[0].cuenta,
                      importe: parseFloat(this.rec_fp_tra_importe)
                  });
                  this.rec_fp_tra_nrocomp = 0;
                  this.rec_fp_tra_idcuenta = "";
                  this.rec_fp_tra_detalle = "";
                  this.rec_fp_tra_importe = 0;
              } else {
                this.MostrarMensaje("Error","Debe ingresar el monto de la transferencia!!!",false);
              }
            } else {
              this.MostrarMensaje("Error","Debe seleccionar cuenta bancaria!!!",false);
            }
          } else {
            this.MostrarMensaje("Error","Debe ingresar detalle del comprobante!!!",false);
          }
        }else{
            this.MostrarMensaje("Error","El nro de comprobante debe tener como máximo 10 cifras!!!",false);
        }
      } else {
        this.MostrarMensaje("Error","Debe ingresar nro de comprobante!!!",false);
      }
    },
    async QuitarCompTransferencia(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].registros.splice(this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].registros.indexOf(item),1);
      }
    },
    AgregaCuentaFPOC() {
      if (this.rec_fp_ocu_numero > 0) {
        if (this.rec_fp_ocu_codigo.length > 0) {
          if (this.rec_fp_ocu_descripcion.length > 0) {
            if (this.rec_fp_ocu_importe > 0) {
              this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].registros.push({banco: "",nro: 0,nrostr: this.rec_fp_ocu_numero + " (" + this.rec_fp_ocu_codigo.trim() + ")",fecha: "",vencimiento: "",alaorden: false, detalle: this.rec_fp_ocu_descripcion.trim(),idcuenta: parseInt(this.rec_fp_ocu_idcuenta),cuenta: this.rec_fp_ocu_descripcion.trim(),importe: parseFloat(this.rec_fp_ocu_importe)});
              this.rec_fp_ocu_idcuenta = 0;
              this.rec_fp_ocu_numero = 0;
              this.rec_fp_ocu_codigo = "";
              this.rec_fp_ocu_descripcion = "";
              this.rec_fp_ocu_importe = 0;
            } else {
              this.MostrarMensaje("Error","Debe ingresar un importe válido!!!",false);
            }
          } else {
            this.MostrarMensaje("Error","Debe ingresar nro de cuenta y dar enter!!",false);
          }
        } else {
          this.MostrarMensaje("Error","Debe ingresar nro de cuenta y dar enter!!!",false);
        }
      } else {
        this.MostrarMensaje("Error","Debe ingresar nro de cuenta y dar enter!!!",false);
      }
    },
    async QuitarCuentaFPOC(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].registros.splice(this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].registros.indexOf(item),1);
      }
    },
    GuardarFormasPago() {
      var errores = "";
      this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].importe = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].importe);
      this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].valordolar = parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].valordolar);
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].importe >0) {
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 10)[0].registros.length === 0) {
          errores = "Si el monto de Efectivo Cajas es mayor a 0 debe ingresar el o los comprobantes de esta forma de pago!!!";
        }
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].importe >0) {
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].registros.length === 0) {
          errores = "Si el monto de Cheques es mayor a 0 debe cargar el o los cheques!!!";
        }
        var totalcheq = 0;
        this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].registros.forEach(function (cheq) {
            cheq.importe=parseFloat(cheq.importe);
            totalcheq += parseFloat(cheq.importe);
        });
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 2)[0].importe != totalcheq) {
          errores = "La suma de montos de Cheques cargados debe ser igual al importe cargado de la forma de pago!!!";
        }
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].importe >0) {
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 12)[0].registros.length === 0) {
          errores = "Si el monto de Depósitos es mayor a 0 debe ingresar el o los comprobantes de esta forma de pago!!!";
        }
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].importe >0) {
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 6)[0].registros.length === 0) {
          errores = "Si el monto de Transferencias es mayor a 0 debe ingresar el o los comprobantes de esta forma de pago!!!";
        }
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe >0) {
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].registros.length === 0) {
          errores = "Si el monto de Otras Cuentas es mayor a 0 debe ingresar la o las cuentas con sus correspondientes importes!!!";
        }
        var totaloc = 0;
        this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].registros.forEach(function (cheq) {
            cheq.importe=parseFloat(cheq.importe);
            totaloc += parseFloat(cheq.importe);
        });
        if (this.recibo.itemsabonos.filter((f) => f.idformapago === 11)[0].importe != totaloc) {
          errores = "La suma de montos de cuentas cargados debe ser igual al importe cargado de la forma de pago!!!";
        }
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].importe >0) {
        this.recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].registroshcc.forEach(function (item) {
            item.imputa=parseFloat(item.imputa);
          });
      }
      if (this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].importe >0 && this.recibo.itemsabonos.filter((f) => f.idformapago === 9)[0].valordolar <= 0) {
        errores = "Si el importe de Dólares es mayor a 0, debe haber un valor del dólar en pesos";
      }
      if (errores.length === 0) {
        this.recibooriginal = {};
        this.Imputaautomatico();
        this.dialogformaspagos = false;
      } else {
        this.MostrarMensaje("Error", errores, false);
      }
    },
    CancelarFormasPago() {
      this.recibo = JSON.parse(JSON.stringify(this.recibooriginal));
      this.dialogformaspagos = false;
    },
    PagoUnicoMatriculaActual() {
      this.loading = true;
      var anio = new Date().getFullYear();
      if (this.pagounico === true) {
        var selec = this.itemsccmatseleccionado;
        this.listaccmatriculado
          .filter(
            (f) =>
              f.cuotaanual === anio &&
              f.idtipocomprobante === 3 &&
              f.cuotanro != null &&
              f.cuotanro > 0
          )
          .forEach(function (item) {
            var indiceaborrar = selec.indexOf(
              selec.filter((m) => m.idmovimientocc === item.idmovimientocc)[0]
            );
            if (indiceaborrar >= 0) {
              selec.splice(indiceaborrar, 1);
            }
            item.isSelectable = false;
          });

        // agregar item de pago contado
        var importe =
          this.catanttitulo === 1
            ? this.cuotaanualactual.cuoanualjovenesPU
            : this.catanttitulo === 2
            ? this.cuotaanualactual.cuoanualmayoresPU
            : 0;
        var reg = {
          idmovimientocc: -99,
          idpersona: this.recibo.idpersona,
          idtipocomprobante: 3,
          tipocomprobante: "CUOTA ANUAL",
          nrocomprobante: 0,
          detalle: "Matricula Anual " + anio.toString() + " - Pago Único",
          vencimiento: this.fechainteresCC,
          fechainteres: this.fechainteresCC,
          importe: importe,
          saldo: importe,
          interes: 0,
          total: importe,
          imputa: importe,
          cuotaanual: anio,
          cuotanro: 0,
        };
        this.listaccmatriculado.push(reg);
        this.itemsccmatseleccionado.push(reg);
        this.loading = false;
      } else {
        this.listaccmatriculado
          .filter((f) => f.cuotaanual === anio)
          .forEach(function (item) {
            item.isSelectable = true;
          });
        this.loading = false;
      }
    },
    sumamontohaber() {
      var sumahaber = 0;
      var i = 0;
      for (i = 0;i<this.recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].registroshcc.length;i++) {
        sumahaber += parseFloat(this.recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].registroshcc[i].imputa);
      }
      this.recibo.itemsabonos.filter((f) => f.idformapago === 99)[0].importe = parseFloat(sumahaber);
      return parseFloat(sumahaber);
    },
    getColor(idestado) {
      if (idestado === 1) return "green";
      else if (idestado === 2) return "red";
      else if (idestado === 3) return "blue";
    },
    fechaFormatoVmenu(date) {
      return (
        date.getFullYear() +
        "-" +
        ((date.getMonth() + 1).toString().length != 2
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "-" +
        (date.getDate().toString().length != 2
          ? "0" + date.getDate()
          : date.getDate())
      );
    },
    Imputaautomatico() {
      this.recibo.itemssaldofavor = [];
      var totaldinero = parseFloat(this.recibo.montoapagar + this.recibo.montodescuentos);
      var nf = 0;
      for (nf = 0; nf < this.recibo.itemsdebe.length; nf++) {
        if (totaldinero >= parseFloat(this.recibo.itemsdebe[nf].importe)) {
          this.recibo.itemsdebe[nf].imputa = parseFloat(this.recibo.itemsdebe[nf].importe).toFixed(4);
          totaldinero = totaldinero - parseFloat(this.recibo.itemsdebe[nf].importe);
        } else {
          this.recibo.itemsdebe[nf].imputa = totaldinero.toFixed(4);
          totaldinero = 0;
        }
      }
      if (parseFloat(totaldinero.toFixed(2)) > 0) {
        var idsf = 0;
        idsf = this.recibo.itemssaldofavor.length > 0 ? this.recibo.itemssaldofavor[this.recibo.itemssaldofavor.length - 1].idsaldofavor : 1;
        this.recibo.itemssaldofavor.push({ idsaldofavor: idsf, concepto: "SALDO A FAVOR EN CC", importe: totaldinero.toFixed(2) });
      }
    },
    AgregarDescuento() {
      this.rec_desc_idtipodescuento = 1;
      this.rec_desc_concepto = "";
      this.rec_desc_importe = 0.0;
      this.rec_desc_porcentaje = 0.0;
      this.dialogdescuento = true;
    },
    async QuitarItemDescuento(item) {
      if (
        await this.$refs.confirm.open(
          "Confirmar Borrado",
          "Esta seguro de querer quitar el registro?"
        )
      ) {
        this.recibo.itemsdescuentos.splice(
          this.recibo.itemsdescuentos.indexOf(item),
          1
        );
        if (this.recibo.montoapagar > 0) {
          this.sumamontodescuentos();
          this.Imputaautomatico();
        }
      }
    },
    GrabarDescuento() {
      if (this.rec_desc_porcentaje > 0 || this.rec_desc_importe > 0) {
        if (this.rec_desc_porcentaje > 0 && this.rec_desc_importe > 0) {
          this.MostrarMensaje(
            "Error",
            "Debe ingresar importe o porcentaje, no puede ingresar valor para ambos!",
            false
          );
        } else {
          if (this.rec_desc_concepto.length > 0) {
            if (
              this.rec_desc_idtipodescuento != 1 ||
              (this.rec_desc_idtipodescuento === 1 &&
                this.estadopagounico === 0)
            ) {
              this.loading = true;
              var iddescuento = 0;
              iddescuento =
                this.recibo.itemsdescuentos.length > 0
                  ? this.recibo.itemsdescuentos[
                      this.recibo.itemsdescuentos.length - 1
                    ].iddescuento
                  : 1;
              var importe =
                this.rec_desc_porcentaje > 0
                  ? (this.rec_desc_porcentaje / 100) * this.recibo.montorecibo
                  : this.rec_desc_importe;
              this.recibo.itemsdescuentos.push({
                iddescuento: iddescuento,
                idtipodescuento: this.rec_desc_idtipodescuento,
                concepto: this.rec_desc_concepto,
                importe: importe,
              });
              this.rec_desc_idtipodescuento = 1;
              this.rec_desc_concepto = "";
              this.rec_desc_importe = 0.0;
              this.rec_desc_porcentaje = 0.0;
              this.dialogdescuento = false;
              if (this.recibo.montoapagar > 0) {
                this.sumamontodescuentos();
                this.Imputaautomatico();
              }
              this.loading = false;
            } else {
              this.MostrarMensaje("Error", this.estadopagounicomensaje, false);
            }
          } else {
            this.MostrarMensaje(
              "Error",
              "Debe ingresar concepto del descuento!",
              false
            );
          }
        }
      } else {
        this.MostrarMensaje(
          "Error",
          "Debe ingresar importe o porcentaje del descuento!",
          false
        );
      }
    },
    actualizalistadeudafp () {
        var total=0;
        this.listadeudafp=[];
        this.recibo.itemsdebe.forEach(function(item) {
            this.listadeudafp.push({concepto: item.concepto, monto: parseFloat(item.imputa).toFixed(2), estilo: 'filadeuda'});
            total= parseFloat(parseFloat(total)+parseFloat(item.imputa));
            //total= parseFloat(total+item.imputa);
        }, this);
        this.recibo.itemsdescuentos.forEach(function(item) {
            this.listadeudafp.push({concepto: item.concepto, monto: parseFloat(item.importe*-1).toFixed(2), estilo: 'filadescuento'});
            //total= parseFloat(total-item.importe);
            total= parseFloat(parseFloat(total)-parseFloat(item.importe));
        }, this);
        this.listadeudafp.push({concepto: 'Total: ', monto: parseFloat(total).toFixed(2), estilo: 'filatotal'});
    },
    seleccionarcuenta (value) {
      if(value!=null){
        this.nuevoitemdebe.numero= value.numero;
        this.nuevoitemdebe.codigo= value.codigo;
        this.nuevoitemdebe.descripcion= value.descripcion;
        this.$refs.importecuentadebe.focus();
      }else{
        this.nuevoitemdebe.numero= '';
        this.nuevoitemdebe.codigo= '';
        this.nuevoitemdebe.descripcion= '';
      }
    },
    seleccionarcuentafpoc (value) {
      if(value!=null){
        this.rec_fp_ocu_idcuenta= value.cuenta;
        this.rec_fp_ocu_numero= value.numero;
        this.rec_fp_ocu_codigo= value.codigo;
        this.rec_fp_ocu_descripcion= value.descripcion;
        this.$refs.rec_fp_ocu_importe.focus();
      }else{
        this.rec_fp_ocu_idcuenta= 0;
        this.rec_fp_ocu_numero= 0;
        this.rec_fp_ocu_codigo= '';
        this.rec_fp_ocu_descripcion= '';
      }
    }
  },
  computed: {
    // a computed getter
    sumaitemsselcc() {
      var suma = 0;
      var i = 0;
      for (i = 0; i < this.itemsccmatseleccionado.length; i++) {
        suma += this.itemsccmatseleccionado[i].total;
      }
      return suma.toFixed(2);
    },
    fechalocalrecibo: function () {
      if (this.recibo.fecha != null && this.recibo.fecha != "") {
        var fecha = new Date(this.recibo.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfinteres: function () {
      if (this.fechainteresCC != null && this.fechainteresCC != "") {
        var fecha = new Date(this.fechainteresCC);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfdesde: function () {
      if (this.filtros.desde != null && this.filtros.desde != "") {
        var fecha = new Date(this.filtros.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfhasta: function () {
      if (this.filtros.hasta != null && this.filtros.hasta != "") {
        var fecha = new Date(this.filtros.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalrec_fp_cheq_fecha: function () {
      if (this.rec_fp_cheq_fecha != null && this.rec_fp_cheq_fecha != "") {
        var fecha = new Date(this.rec_fp_cheq_fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalrec_fp_cheq_vencimiento: function () {
      if (
        this.rec_fp_cheq_vencimiento != null &&
        this.rec_fp_cheq_vencimiento != ""
      ) {
        var fecha = new Date(this.rec_fp_cheq_vencimiento);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.filadeuda td {
    color: red;
}

.filadescuento td {
    color: green;
}

.filatotal td {
    color: blue;
}

.titulocardchico {
  padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  color: white;
  background-color: dimgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegrita {
  font-weight: bold !important;
}
.textoNegritaTitulo {
  font-weight: bold !important;
  font-size: medium;
}
.textoNegritaMontos {
  font-weight: bold !important;
  font-size: 12pt;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.container {
  max-width: unset !important;
}
</style>
